export default __webpack_public_path__ + "static/jaizkibel-cea5d8569b10961244cd368b97d37ddb.png";